export function stringValueFromObject(key: string, obj: object): string | undefined {
  const value = obj[key as keyof typeof obj]
  return typeof value === 'string' && value ? value : undefined
}
